<template>
  <div class="touchpoints-analysis-wrap">
    <div v-if="!isLoading && allHeaders.length > 0">
      <v-row>
        <v-col cols="6" class="d-flex align-center">
          <div class="mt-5 mr-4">Select touchpoints&nbsp;:</div>
          <v-combobox
            :items="allHeaders"
            multiple
            v-model="selectedHeaders"
            hide-details
          >
            <template v-slot:selection="{ index }">
              <span v-if="index === 0">
                {{selectedHeaders.length}}&nbsp;of&nbsp;{{allHeaders.length}}&nbsp;touchpoints selected
              </span>
            </template>
            <template v-slot:prepend-item>
              <v-list-item @click="toggle()">
                <v-list-item-action>
                  <v-icon class="ml-n1" :color="selectedHeaders.length > 0 ? 'primary' : ''">{{ icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="4">
        </v-col>
        <v-col cols="2" class="d-flex justify-end pt-4 mt-4" v-if="selectedHeaders.length > 0">
          <div class="pre-icon cursor-pointer mr-3" @click="displayPre()">
            <i class="las la-chevron-circle-left"></i>
          </div>
          <div v-if="selectedHeaders.length > 0">
            <span v-if="selectedHeaders.length > 0">{{startlimit+1}}</span>
            <span v-else>0</span>
            <span>-</span>
            <span>{{endlimit}}</span>
            <span>&nbsp;of&nbsp;</span>
            <span>&nbsp;{{selectedHeaders.length}}&nbsp;</span>
          </div>
          <div class="next-icon cursor-pointer ml-3" @click="displayNext()">
            <i class="las la-chevron-circle-right"></i>
          </div>
        </v-col>
      </v-row>
      <div class="tableFixHead pb-7">
        <div class="table-wrap">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="am-table-head">
                  <div class="left-header">
                    <div class="hidden-wrap">&nbsp;</div>
                    <div class="score-wrap">
                      <div>&nbsp;</div>
                      <div class="icon-wrap" style="visibility: hidden;">&nbsp;</div>
                    </div>
                  </div>
                </th>
                <th class="overall-score">
                  <div class="stat-data">
                    <span>
                      Overall Score
                    </span>
                  </div>
                </th>
                <th
                  v-for="(header, idx) in activeHeaders"
                  :key="idx"
                  class=""
                >
                  <div class="stat-data">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{header.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span>
                      </template>
                      <span class="text-capitalize">{{header.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span>
                    </v-tooltip>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(row, driver) in tableData"
              >
                <tr :key="`${driver}`" :class="driver === activeDriver ? 'activeDriver' : 'driver'">
                  <td class="am-table-row">
                    <div class="left-row d-flex justify-space-between">
                      <div class="score-wrap">
                        <div class="icon-wrap" @click="toggleDriver(driver)">
                          <i :ref="`${driver}-hide`" class="las la-angle-down" style="font-size: 16px !important;display:none;"></i>
                          <i :ref="`${driver}-show`" class="las la-angle-right" style="font-size: 16px !important;"></i>
                          <!-- <i class="las la-angle-down" style="font-size: 16px !important;display:none;"></i>
                          <i class="las la-angle-right" style="font-size: 16px !important;"></i> -->
                        </div>
                      <!-- </div>
                      <div class=""> -->
                        <div class="">
                          <div class="subdriver-name" @click="viewDriver(driver)">{{driver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</div>
                          <div class="analysis-sub">It has {{Object.keys(tableData[driver].sub_drivers).length}} sub drivers</div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="score subdriver-data" :style="`background-color:${getColor(row.average)}`">
                    {{row.average}}
                  </td>
                  <td
                    v-for="(header, key) in activeHeaders"
                    :key="key"
                    :class="header"
                    class="subdriver-data cursor-pointer"
                    :style="`background-color:${getColor(getValue(driver, header))}`"
                  >
                    <span v-if="getValue(driver, header)" @click="viewDriverWithScore(driver, header)">{{getValue(driver, header).toFixed(1)}}</span>
                    <span v-else>--</span>
                  </td>
                </tr>
                <template
                  v-for="(sd, subdriver) in tableData[driver].sub_drivers">
                  <tr
                    :key="`${subdriver}-${driver}-subdriver`"
                    :ref="driver"
                    :class="driver === activeDriver ? 'activeSubDriver' : ''"
                    :id="subdriver"
                    style="display:none;"
                  >
                    <td class="am-table-row">
                      <div class="left-row d-flex justify-space-between">
                        <div class="score-wrap">
                          <div class="icon-wrap" @click="toggleSubDriver(subdriver)">
                            <i :ref="`${subdriver}-hide`" :class="`${driver}-subDriverHide`" class="las la-minus" style="font-size: 16px !important;display:none;"></i>
                            <i :ref="`${subdriver}-show`" :class="`${driver}-subDriverShow`" class="las la-plus" style="font-size: 16px !important;display:block;"></i>
                          </div>
                          <div>
                            <div class="subdriver-name" @click="viewSubDriver(driver, subdriver)">{{subdriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</div>
                            <div class="analysis-sub">
                              It has {{Object.keys(tableData[driver].sub_drivers[subdriver].questions).length}} questions
                            </div>
                          </div>
                        </div>
                        <div></div>
                      </div>
                    </td>
                    <td class="score subdriver-data" :style="`background-color:${getColor(sd.average)}`">
                      {{sd.average}}
                    </td>
                    <td
                      v-for="(header, key) in activeHeaders"
                      :key="key"
                      :class="header"
                      class="subdriver-data cursor-pointer"
                      :style="`background-color:${getColor(getSubDriverValue(driver, subdriver, header))}`"
                    >
                      <span v-if="getSubDriverValue(driver, subdriver, header)"
                        @click="viewSubDriverWithScore(driver, subdriver, header)"
                      >
                        {{getSubDriverValue(driver, subdriver, header).toFixed(1)}}
                      </span>
                      <span v-else>--</span>
                    </td>
                  </tr>
                  <!-- :key="`${subdriver}-${driver}-subdriver`" -->
                  <tr
                    v-for="(q, key) in tableData[driver].sub_drivers[subdriver].questions"
                    :key="`${driver}-${subdriver}-${key}-question`"
                    :ref="subdriver"
                    :id="key"
                    :class="driver === activeDriver ? `activeQuestion ${driver}` : ''"
                    style="display:none;"
                  >
                    <td class="am-table-row">
                      <div class="left-row">
                          <div class="score-wrap">
                            <div class="icon-wrap">
                              <i class="las la-dot-circle" style="font-size: 16px !important;"></i>
                            </div>
                          <div class="subdriver-question" @click="viewQuestion(driver, subdriver, key)">{{key}}</div>
                        </div>
                      </div>
                    </td>
                    <td
                      class="subdriver-data"
                      :style="`background-color:${getColor(q.average)}`"
                    >
                      {{q.average}}
                    </td>
                    <td
                      v-for="(header, idx) in activeHeaders"
                      :key="idx"
                      class="subdriver-data cursor-pointer"
                      :style="`background-color:${getColor(getQuestionValue(driver, subdriver, key, header))}`"
                    >
                      <span v-if="getQuestionValue(driver, subdriver, key, header)"
                        @click="viewQuestionWithScore(driver, subdriver, key, header)"
                      >
                        {{getQuestionValue(driver, subdriver, key, header).toFixed(1)}}
                      </span>
                      <span v-else>--</span>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <v-row no-gutters class="pt-5 mt-5">
        <v-col cols="3"></v-col>
        <v-col cols="9">
          <div class="driver-heatmap-range">
            <v-row no-gutters>
              <v-col>
                <span class="heat one">&nbsp;</span>
              </v-col>
              <v-col>
                <span class="heat two">&nbsp;</span>
              </v-col>
              <v-col>
                <span class="heat three">&nbsp;</span>
              </v-col>
              <v-col>
                <span class="heat four">&nbsp;</span>
              </v-col>
              <v-col>
                <span class="heat five">&nbsp;</span>
              </v-col>
              <v-col>
                <span class="heat six">&nbsp;</span>
              </v-col>
              <v-col>
                <span class="heat seven">&nbsp;</span>
              </v-col>
              <v-col>
                <span class="heat eight">&nbsp;</span>
              </v-col>
              <v-col>
                <span class="heat nine">&nbsp;</span>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="3"></v-col>
        <v-col cols="9">
          <div class="driver-heatmap-range">
            <v-row no-gutters>
              <v-col class="text-left">
                <div>Disengaged</div>
              </v-col>
              <v-col class="text-center">
                <div>Passively engaged</div>
              </v-col>
              <v-col class="text-right">
                <div>Highly engaged</div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-row v-if="!isLoading && allHeaders.length === 0">
      <v-col cols="12" class="no-data">
        Not enough data to generate analysis
      </v-col>
    </v-row>
    <amara-loader
      v-show="isLoading"
    ></amara-loader>
  </div>
</template>

<script>
import axios from 'axios';

import AmaraLoader from '../../elements/amara-loader';

import TouchpointsMixin from './touchpoints-mixin';

export default {
  name: 'TouchpointAnaysis',

  mixins: [TouchpointsMixin],

  components: {
    AmaraLoader
  },

  data () {
    return {
      isLoading: true,
      selectedHeaders: [],
      activeDriver: null,
      activeSubDriver: 'Collaboration',
      subDrivers: {
        Collaboration: { average: 1.5, delhi: 4.5, mumbai: 3.5, kolkata: 2.9, banglore: 3.2, goa: 4.5, haryana: 1.8, dubai: 1.8, USA: 1.8, london: 1.8 },
        Relationships: { average: 2.5, delhi: 3.2, mumbai: 2.2, kolkata: 2.1, banglore: 1.5, goa: 2.2, haryana: 3.6, dubai: 1.8, USA: 3.8, london: 4.8 },
        WorkEnvironment: { average: 3.6, delhi: 1.8, mumbai: 4.3, kolkata: 4.5, banglore: 3.2, goa: 4.5, haryana: 1.8, dubai: 1.8, USA: 1.8, london: 2.8 },
        environment: { average: 2.8, delhi: 4.5, mumbai: 2.5, kolkata: 2.9, banglore: 3.2, goa: 4.5, haryana: 1.8, dubai: 1.8, USA: 1.8, london: 1.8 },
        peerRelationship: { average: 1.9, delhi: 2.9, mumbai: 3.9, kolkata: 4.2, banglore: 1.3, goa: 2.1, haryana: 3.2, dubai: 1.8, USA: 4.8, london: 1.8 },
        Onboarding: { average: 4.7, delhi: 4.5, mumbai: 2.5, kolkata: 2.9, banglore: 2.1, goa: 0.9, haryana: 2.1, dubai: 1.8, USA: 1.8, london: 1.8 }
      },
      questions: {
        'How were your last 6 months in Getz Pharma?': { average: 1.1, delhi: 3.5, mumbai: 1.5, kolkata: 3.9, banglore: 2.2, goa: 3.5, haryana: 2.8, dubai: 1.8, USA: 1.8, london: 1.8, philippines: 1.8, 'united arab emirates': 3.8 },
        'Do you have fun at work?': { average: 1.5, delhi: 4.5, mumbai: 3.5, kolkata: 2.9, banglore: 3.2, goa: 4.5, haryana: 1.8, dubai: 1.8, USA: 1.8, london: 1.8, philippines: 1.6, 'united arab emirates': 1.8 },
        'Can you voice out your concerns with your manager without feeling any threat?': { average: 2.5, delhi: 3.2, mumbai: 2.2, kolkata: 2.1, banglore: 1.5, goa: 2.2, haryana: 3.6, dubai: 1.8, USA: 3.8, london: 4.8, philippines: 1.8, 'united arab emirates': 4.1 },
        'Do you understand how your work goals relate to the organization goals?': { average: 3.6, delhi: 1.8, mumbai: 4.3, kolkata: 4.5, banglore: 3.2, goa: 4.5, haryana: 1.8, dubai: 1.8, USA: 1.8, london: 2.8, philippines: 1.8, 'united arab emirates': 4.5 },
        'Are you provided with enough opportunities to enhance your skills?': { average: 2.8, delhi: 4.5, mumbai: 2.5, kolkata: 2.9, banglore: 3.2, goa: 4.5, haryana: 1.8, dubai: 1.8, USA: 1.8, london: 1.8, philippines: 1.8, 'united arab emirates': 1.8 },
        'Are there effective programs for recognising and rewarding achievements?': { average: 1.9, delhi: 2.9, mumbai: 3.9, kolkata: 4.2, banglore: 1.3, goa: 2.1, haryana: 3.2, dubai: 1.8, USA: 4.8, london: 1.8, philippines: 1.2, 'united arab emirates': 0.8 },
        'What is the one thing you would like to improve in Getz Pharma?': { average: 4.7, delhi: 4.5, mumbai: 2.5, kolkata: 2.9, banglore: 2.1, goa: 0.9, haryana: 2.1, dubai: 1.8, USA: 1.8, london: 1.8, philippines: 1.8, 'united arab emirates': 3.8 }
      },
      // tableHeaders: [],
      activeHeaders: [],
      tableData: {},
      page: 0,
      limit: 8,
      allHeaders: [],
      totalData: null,
      endlimit: null,
      startlimit: null,
      lastActiveSubDriver: null,
      lastActiveQuestion: null
    };
  },

  beforeMount () {
    this.getTable();
  },

  mounted () {
    // this.getTableHeaders();
    // this.display(this.page);
  },

  watch: {
    selectedHeaders: {
      deep: true,
      handler () {
        if (this.selectedHeaders.length === 0) {
          this.activeHeaders = [];
        }
        if (this.selectedHeaders.length === this.allHeaders.length) {
          this.display(this.page);
        }
        if (this.selectedHeaders.length <= this.limit) {
          this.compareCustom(this.page);
        }
      }
    }
  },

  computed: {
    icon () {
      if (this.allOptionSelected) return 'lar la-window-close';
      if (this.someOptionSelected) return 'lar la-minus-square';
      return 'las la-stop';
    },
    allOptionSelected () {
      return this.selectedHeaders.length === this.allHeaders.length;
    },
    someOptionSelected () {
      return this.selectedHeaders.length > 0 && !this.allOptionSelected;
    }
  },

  methods: {
    viewDriver (driver) {
      const temp = {
        ...this.updateDashboardFilters
      };
      this.$router.push({
        path: '/drivers/view',
        query: {
          driver,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    viewDriverWithScore (driver, stage) {
      const temp = {
        stage__title__in: stage || undefined,
        ...this.updateDashboardFilters
      };
      this.$router.push({
        path: '/drivers/view',
        query: {
          driver,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    viewSubDriver (driver, subdriver) {
      const temp = {
        ...this.updateDashboardFilters
      };
      this.$router.push({
        path: '/drivers/view/subdriver',
        query: {
          subdriver,
          driver,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    viewSubDriverWithScore (driver, subdriver, stage) {
      const temp = {
        stage__title__in: stage || undefined,
        ...this.updateDashboardFilters
      };
      this.$router.push({
        path: '/drivers/view/subdriver',
        query: {
          driver,
          subdriver,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    viewQuestion (driver, subdriver, question) {
      const temp = {
        ...this.updateDashboardFilters
      };
      this.$router.push({
        path: '/drivers/view/questions',
        query: {
          driver,
          subdriver,
          question,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    viewQuestionWithScore (driver, subdriver, question, stage) {
      const temp = {
        stage__title__in: stage || undefined,
        ...this.updateDashboardFilters
      };
      this.$router.push({
        path: '/drivers/view/questions',
        query: {
          driver,
          subdriver,
          question,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    getTable () {
      this.isLoading = true;
      const filters = Object.assign({}, this.updateDashboardFilters);
      if (filters && filters.filters) {
        delete filters.filters;
      }
      const queryParams = {
        ...filters
      };
      if (this.updateDashboardFilters && this.updateDashboardFilters.filters) {
        this.$lodash.each(this.updateDashboardFilters.filters, (v, k) => {
          if (v.length > 0) {
            queryParams[`user__profile__${k}__in`] = v.join();
          }
        });
      }
      axios.get(`${process.env.VUE_APP_API_URL}stage/engagement_heatmap`, {
        params: queryParams
      }).then((response) => {
        if (response && response.status === 200) {
          this.allHeaders = response.data.report_headers;
          this.tableData = response.data.stage_engagement_heatmap;
          this.getTableHeaders();
          this.display(this.page);
          this.isLoading = false;
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch touchpoints, Please try again later!'
          });
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch touchpoints, Please try again later!'
          });
        }
      });
    },
    getTableHeaders () {
      this.selectedHeaders = this.allHeaders;
      this.totalData = this.allHeaders.length;
    },
    displayPre () {
      if (this.page <= 0) {
        return;
      }
      this.page = this.page - 1;
      this.display(this.page);
    },
    displayNext () {
      if (this.endlimit >= this.totalData) {
        return;
      }
      if (this.page < (this.totalData / this.limit)) {
        this.page = this.page + 1;
        this.display(this.page);
      }
    },
    display (page) {
      if (page < 0) {
        return;
      }
      const start = this.limit * page;
      const end = this.page * this.limit + this.limit;
      this.startlimit = start;
      this.endlimit = end;
      this.selectedHeaders = this.allHeaders;
      if (this.endlimit > this.selectedHeaders.length) {
        this.endlimit = this.selectedHeaders.length;
      }
      const tempData = this.selectedHeaders.slice(this.startlimit, this.endlimit);
      this.activeHeaders = tempData;
    },
    compareCustom (page) {
      if (page < 0) {
        return;
      }
      const start = this.limit * page;
      const end = this.page * this.limit + this.limit;
      this.startlimit = start;
      this.endlimit = end;
      if (this.endlimit > this.selectedHeaders.length) {
        this.endlimit = this.selectedHeaders.length;
      }
      const tempData = this.selectedHeaders.slice(this.startlimit, this.endlimit);
      this.totalData = tempData.length;
      this.activeHeaders = tempData;
    },
    getValue (driver, header) {
      return this.tableData[driver].demographic_wise_avarage[header];
    },
    getSubDriverValue (driver, subDriver, header) {
      return this.tableData[driver].sub_drivers[subDriver].demographic_wise_avarage[header];
    },
    getQuestionValue (driver, subDriver, question, header) {
      if (this.tableData[driver] && this.tableData[driver].sub_drivers[subDriver] && this.tableData[driver].sub_drivers[subDriver].questions[question]) {
        return this.tableData[driver].sub_drivers[subDriver].questions[question].demographic_wise_avarage[header];
      }
    },
    toggleDriver (driver) {
      this.activeDriver = driver;
      const Drivers = Object.keys(this.tableData);
      const activeSubdrivers = Object.keys(this.tableData[driver].sub_drivers);
      this.lastActiveSubDriver = activeSubdrivers[activeSubdrivers.length - 1];
      const tempElement = document.getElementById(this.lastActiveSubDriver);
      tempElement.style.borderBottom = '2px solid rgba(0, 0, 0, 0.2)';
      // console.log('toggleDriver -> tempElement', tempElement.style);
      this.$lodash.each(Drivers, (val) => {
        if (val !== driver) {
          // reset subdrivers icons end
          this.$lodash.each(this.$refs[val], (value, key) => {
            value.style.display = 'none';
          });
        }
        // reset driver icons start
        this.$refs[`${val}-show`][0].style.display = 'block';
        this.$refs[`${val}-hide`][0].style.display = 'none';
        // reset drivers icons end
        // disable questions start
        const tempQuestions = document.getElementsByClassName(val);
        this.$lodash.each(tempQuestions, (val) => {
          val.style.display = 'none';
        });
        // disable questions end
        // reset subdrivers icons start
        const subDriverShowIcon = document.getElementsByClassName(`${val}-subDriverShow`);
        const subDriverHideIcon = document.getElementsByClassName(`${val}-subDriverHide`);
        this.$lodash.each(subDriverShowIcon, (value) => {
          value.style.display = 'block';
        });
        this.$lodash.each(subDriverHideIcon, (value) => {
          value.style.display = 'none';
        });
      });
      if (this.$refs[driver][0].style.display === 'none') {
        this.$refs[`${driver}-show`][0].style.display = 'none';
        this.$refs[`${driver}-hide`][0].style.display = 'block';
        this.$lodash.each(this.$refs[driver], (val, key) => {
          val.style.display = 'table-row';
        });
      } else {
        this.$refs[`${driver}-show`][0].style.display = 'block';
        this.$refs[`${driver}-hide`][0].style.display = 'none';
        this.$lodash.each(this.$refs[driver], (val) => {
          val.style.display = 'none';
        });
        const tempQuestions = document.getElementsByClassName(driver);
        this.$lodash.each(tempQuestions, (val) => {
          val.style.display = 'none';
        });
        this.activeDriver = null;
      }
    },
    removeBorderOfSubDriver () {
      const tempElement = document.getElementById(this.lastActiveSubDriver);
      const icon = this.$refs[`${this.lastActiveSubDriver}-hide`][0].style.display;
      if (icon === 'none') {
        tempElement.style.borderBottom = '0';
      } else {
        tempElement.style.borderBottom = '2px solid rgba(0, 0, 0, 0.2)';
      }
    },
    toggleSubDriver (subDriver) {
      // const subDrivers = Object.keys(this.tableData[this.activeDriver].sub_drivers);
      // this.$lodash.each(subDrivers, (val) => {
      //   // console.log('toggleSubDriver -> val', val);
      //   if (val !== subDriver) {
      //     this.$lodash.each(this.$refs[val], (value) => {
      //       value.style.display = 'none';
      //     });
      //   }
      // });
      const activeQuestion = Object.keys(this.tableData[this.activeDriver].sub_drivers[this.lastActiveSubDriver].questions);
      this.lastActiveQuestion = activeQuestion[activeQuestion.length - 1];
      const tempElement = document.getElementById(this.lastActiveQuestion);
      tempElement.style.borderBottom = '2px solid rgba(0, 0, 0, 0.2)';
      if (subDriver === this.lastActiveSubDriver) {
        this.removeBorderOfSubDriver();
      }
      if (this.$refs[subDriver][0].style.display === 'none') {
        this.$refs[`${subDriver}-show`][0].style.display = 'none';
        this.$refs[`${subDriver}-hide`][0].style.display = 'block';
        this.$lodash.each(this.$refs[subDriver], (val) => {
          val.style.display = 'table-row';
        });
      } else {
        this.$refs[`${subDriver}-show`][0].style.display = 'block';
        this.$refs[`${subDriver}-hide`][0].style.display = 'none';
        this.$lodash.each(this.$refs[subDriver], (val) => {
          val.style.display = 'none';
        });
      }
    },
    getColor (val) {
      if (val) {
        let color = '#ffffff';
        const radixPos = String(val).indexOf('.');
        let value = String(val).slice(radixPos).split('.')[1];
        if (!value) {
          value = 0;
        }
        if (val > 0 && val <= 1) {
          color = `rgba(244, 67, 54, 0.${(10 - Number(value)) + 80})`;
        }
        if (val > 1 && val <= 2) {
          color = `rgba(244, 67, 54, 0.${(10 - Number(value)) + 60})`;
        }
        if (val > 2 && val <= 3) {
          color = `rgba(244, 67, 54, 0.${(10 - Number(value)) + 40})`;
        }
        if (val > 3 && val < 4) {
          color = `rgba(246, 251, 252, 0.${Number(value)})`;
        }
        if (val === 4) {
          color = 'rgba(246, 251, 252, 1)';
        }
        if (val > 4 && val < 5) {
          color = `rgba(100, 231, 100, 0.${(Number(value))})`;
        }
        if (val === 5) {
          color = 'rgba(100, 231, 100, 1)';
        }
        return color;
      }
      if (val === 0) {
        return 'rgba(244, 67, 54, 1)';
      }
    },
    toggle () {
      this.$nextTick(() => {
        if (this.allOptionSelected) {
          this.selectedHeaders = [];
          this.activeHeaders = [];
        } else {
          this.display(this.page);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.touchpoints-analysis-wrap {
  padding:16px;
  background: #fff;
  margin: 12px;
  border-radius: 6px;
  // box-shadow: 0 4px 20px 1px rgba(0,0,0,.06), 0 1px 4px rgba(0,0,0,.08) !important;
  box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
  .no-data {
    width: 100%;
    text-align: center;
    height: 6rem;
    align-items: center;
    display: flex;
    justify-content: center;
    border: none !important;
  }
  .tableFixHead {
    position:relative;
    // overflow-x: auto;
    // background: #fbfcff !important;
    min-height: 50vh;
    .analysis-sub {
      font-size: var(--content-sub-size);
      color: var(--color-palceholder);
      padding: 0;
      text-align: left;
    }
    .table-wrap {
      // width:100%;
    }
    .table-bordered {
      // width: 100%;
      margin: 0 !important;
    }
    table {
      border-collapse: collapse;
    }
    td {
      padding: 8px 16px;
    }
    th {
      padding: 8px;
      border: 1px solid rgba(0,0,0,0.1);
      background: #fff;
      .stat-data {
        text-transform: capitalize;
        max-width: 125px;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-word;
        white-space: nowrap;
        padding: 0;
        text-align: center;
      }
      &.overall-score {
        border: 2px solid rgba(0,0,0,0.2) !important;
        background-color: rgba(0,0,0,0.02);
        .stat-data {
          font-weight: 600;
        }
      }
    }
    tbody {
      tr {
        // border: 1px solid rgba(0,0,0,0.1);
        td {
          text-align: center;
        }
      }
      .driver {
        border: 1px solid rgba(0,0,0,0.1);
      }
    }
    td:first-child, th:first-child {
      // position:sticky;
      // left:0;
      // z-index:1;
      // background-color:transparent;
    }
    .am-table-head {
      // position: sticky;
      z-index: 0;
      justify-content: space-between;
      min-width: 350px;
      background: #ffffff !important;
      width: 100%;
      .left-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        .score-wrap {
          display: flex;
          th {
            border: 0;
          }
          .icon-wrap {
            pointer-events: none;
          }
        }
      }
    }
    .am-table-row {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      min-width: 300px;
      background: #ffffff !important;
      border-bottom: 0;
      padding: 0 !important;
      border: 1px solid rgba(0,0,0,0.1);
      .left-row {
        display: flex;
        width: 100%;
        padding: 8px 16px !important;
        // padding: 16px !important;
        .left-wrap {
          padding: 8px 16px;
        }
        .score {
          padding: 8px 13px;
          border-left: 1px solid rgba(0, 0, 0, 0.05);
          width: 80px;
        }
        .score-wrap {
          display: flex;
          .icon-wrap {
            cursor: pointer;
            padding-top: 4px;
            padding-right: 16px;
          }
        }
        .subdriver-name {
          text-transform: capitalize;
          font-weight: 600;
          text-align: left;
        }
        .subdriver-question {
          font-weight: 500;
          text-align: left;
        }
      }
    }
    .score {
      font-weight: 600;
      border: 2px solid rgba(0,0,0,0.2) !important;
    }
    .question-analysis {
      // display: none;
      .am-table-row {
        background-color: rgba(0,0,0,0.015) !important;
        box-shadow: unset;
        .left-row {
          cursor: pointer;
        }
      }
    }
    .subdriver-analysis {
      .am-table-row {
        background-color: rgba(0,0,0,0.025) !important;
        box-shadow: unset;
        .left-row {
          cursor: pointer;
        }
      }
    }
    .subdriver-data {
      background: #ffffff;
      border: 1px solid rgba(0,0,0,0.05);
      font-weight: 600;
    }
  }
  .driver-heatmap-range {
    .heat {
      height: 12px;
      text-align: center;
      display: block;
      &.one {
        background-color: rgba(244, 67, 54, 1);
      }
      &.two {
        background-color: rgba(244, 67, 54, 0.8);
      }
      &.three {
        background-color: rgba(244, 67, 54, 0.4);
      }
      &.four {
        background-color: rgba(246, 251, 252, 0.6);
      }
      &.five {
        background-color: rgba(246, 251, 252, 0.8);
      }
      &.six {
        background-color: rgba(246, 251, 252, 1);
      }
      &.seven {
        background-color: rgba(100, 231, 100, 0.6);
      }
      &.eight {
        background-color: rgba(100, 231, 100, 0.8);
      }
      &.nine {
        background-color: rgba(100, 231, 100, 1);
      }
    }
  }
  .activeDriver {
    border: 2px solid rgba(0,0,0,0.2);
    border-bottom: 0;
    .am-table-row {
      background-color: rgba(0, 0, 0, 0.1) !important;
    }
  }
  .activeSubDriver {
    border: 2px solid rgba(0,0,0,0.2);
    border-bottom: 0;
    border-top: 0;
    .am-table-row {
      background-color: rgba(0, 0, 0, 0.06) !important;
    }
  }
  .activeQuestion {
    border: 2px solid rgba(0,0,0,0.2);
    border-bottom: 0;
    border-top: 0;
    .am-table-row {
      background-color: rgba(0, 0, 0, 0.02) !important;
    }
  }
}
</style>

<style scoped>
.touchpoints-analysis-wrap[min-width~="1075"] .table-wrap {
  overflow-x: auto;
}
</style>
